module.exports = __webpack_public_path__ + "static/img/3.0d24218.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/huawei/3.png
// module id = q1Bg
// module chunks = 0